import { render } from "./CatHeaders.vue?vue&type=template&id=74e7a758"
import script from "./CatHeaders.vue?vue&type=script&lang=js"
export * from "./CatHeaders.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__